<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="CT ParaOverride-1" id="_idParaDest-3"> </p>
<p class="HT">CARDIFF, BY THE SEA</p>
<p class="BT1stPara ParaOverride-4"><span class="CharOverride-2">Four Novellas</span></p>
<p class="BT1stPara ParaOverride-3"><span class="CharOverride-2">of Suspense</span></p>
<p class="BT ParaOverride-5"><span class="CharOverride-3">Joyce Carol Oates</span></p>
<p class="Basic-Paragraph ParaOverride-6"><span class="CharOverride-4"><img alt="" class="_idGenObjectAttribute-1" src="image/Mysteriouslogo.jpg"/></span></p>
<p class="BT1stPara ParaOverride-7">The Mysterious Press</p>
<p class="BT1stPara ParaOverride-7"><span class="CharOverride-5">New York</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780802158017-2.vue?10942212